import React from 'react'
import { Box, Stack } from '@mui/material'
import classNames from 'classnames'

import type {
  NotesSoapTemplateWidget,
  SoapTemplateWidget,
} from '~/api/graphql/generated/types'
import type { Modify, SoapTemplateTab } from '~/types'

import SoapRecordSection from './appointment/SoapRecordSection'
import { SoapMenu } from './soap-menu/SoapMenu'
import SoapWidgetItem from './SoapWidgetItem'

interface SoapMainContentProps {
  currentTab: Modify<SoapTemplateTab, { id: string }> | undefined
  hideHeader?: boolean
  hideSoapRail: () => void
  rightRailVisible: boolean
  soapRailClasses: {
    contentWithRail: string
    contentWithoutRail: string
    expandedRail: string
    hidden: string
    rightRail: string
  }
  soapTabs: Modify<SoapTemplateTab, { id: string }>[] | undefined
}

export const SoapMainContent = ({
  soapTabs,
  soapRailClasses,
  rightRailVisible,
  currentTab,
  hideSoapRail,
  hideHeader = false,
}: SoapMainContentProps) => (
  <>
    <SoapMenu hideHeader={hideHeader} tabs={soapTabs} />
    <Box
      className={classNames({
        [soapRailClasses.contentWithoutRail]: !rightRailVisible,
        [soapRailClasses.contentWithRail]: rightRailVisible,
      })}
      data-testid="soap-page-wrapper"
      id="soap-page-wrapper"
      p={2}
    >
      <SoapRecordSection />
      <Stack spacing={2}>
        {currentTab?.widgets.map(
          (widget: SoapTemplateWidget | NotesSoapTemplateWidget) => {
            const { active, id, marketplaceId, soapWidgetId } = widget
            const hasDefaultTemplates =
              'defaultDischargeNotesTemplate' in widget ||
              'defaultMedicalNotesTemplate' in widget
            const templateIds = hasDefaultTemplates
              ? {
                  defaultDischargeNotesTemplateId:
                    widget.defaultDischargeNotesTemplate?.id,
                  defaultMedicalNotesTemplateId:
                    widget.defaultMedicalNotesTemplate?.id,
                }
              : undefined

            return (
              <SoapWidgetItem
                active={active}
                key={id}
                marketplaceId={marketplaceId}
                soapWidgetId={soapWidgetId}
                onHideSoapRail={hideSoapRail}
                {...templateIds}
              />
            )
          },
        )}
      </Stack>
    </Box>
  </>
)
